import { Box, Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useEmpaquetado from '../../../../../hooks/useEmpaquetado';
import DialogAddInvetario from './addInventario/DialogAddInvetario';
import ListaEmpaque from './listaEmpaquetado/ListaEmpaque';

function Section6({ dataUser }) {
  const [empaqueUser, setEmpaqueUser] = useState(null);
  const { getEmpaqueItemsOwnerUser, generateEmpaqueUser } = useEmpaquetado();

  console.log('el empaque del user', empaqueUser);
  const generateEmpaqueRegistro = () => {
    generateEmpaqueUser(dataUser.id);
  };

  useEffect(() => {
    async function getData() {
      getEmpaqueItemsOwnerUser(dataUser.id, setEmpaqueUser);
    }
    getData();
  }, [dataUser.id, getEmpaqueItemsOwnerUser]);
  return (
    <Box>
      {!empaqueUser && (
        <Box textAlign="center">
          <Typography>Este usuario aun no inicializó cu registro de empaques.</Typography>
          <Typography variant="subtitle1">¿Desea inicializar su registro?</Typography>
          <Button onClick={generateEmpaqueRegistro} variant="contained">
            Inicializar
          </Button>
        </Box>
      )}

      {empaqueUser && (
        <>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', marginBottom: '15px' }}>
            <DialogAddInvetario dataUser={dataUser} />
          </Box>
          {empaqueUser.empaqueItems.length > 0 && <ListaEmpaque items={empaqueUser.empaqueItems} />}
          {empaqueUser.empaqueItems.length <= 0 && (
            <Typography variant="subtitle1" textAlign="center">
              El inventario de empaques de este usuario esta vacio.
            </Typography>
          )}
        </>
      )}
    </Box>
  );
}

export default Section6;
